import { Form, Row, Select } from "antd";
import { getListProjects } from "apis/projects";
import React, { useEffect, useState } from "react";
import { t } from "utils/i18n";

const PAGE_SIZE = 199;
const MAX_PAGES = 50;

export default ({ projectId, setProjectId }) => {
  const [loadingSelect, setLoadingSelect] = useState(false);
  const [listProject, setListProject] = useState([]);

  useEffect(() => {
    let cancelled = false;

    const fetchAllProjects = async () => {
      setLoadingSelect(true);
      const all = [];
      for (let page = 1; page <= MAX_PAGES; page++) {
        const response = await getListProjects({
          page,
          limit: PAGE_SIZE,
          sort_by: "updated_at",
          order: "DESC",
        });
        if (response.status !== 200) break;
        const rows = response.data.data || [];
        all.push(...rows);
        if (rows.length < PAGE_SIZE) break;
      }
      if (!cancelled) {
        const unique = Array.from(new Map(all.map(p => [p.project_id, p])).values());
        setListProject(unique);
        setLoadingSelect(false);
      }
    };

    fetchAllProjects();
    return () => { cancelled = true; };
  }, []);

  return (
    <Row style={{ width: "100%" }}>
      <Form layout="inline">
        <Form.Item label={t("Project")}>
          <Select
            value={projectId}
            onChange={setProjectId}
            loading={loadingSelect}
            style={{ width: 200 }}
            allowClear
            showSearch
            placeholder={t("Please select project")}
            optionFilterProp="label"
          >
            {listProject.map(p => (
              <Select.Option value={p.project_id} key={p.project_id} label={p.name}>
                {p.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
    </Row>
  );
};